import React from "react";
import TipButton from "../../../common/offer-grid/tip-button/TipButton";

export function OfferTips(props) {
	const { tipsToRender, isGridTips } = props;

	const shouldAddPlaceHolder =
		tipsToRender.length > 0 && tipsToRender.length <= 3;

	return tipsToRender.map((tip, idx) => {
		if (tip == null || Object.keys(tip).length === 0) {
			/** If tip is null or is empty object. */
			return;
		}

		const tipKey =
			(tip.tip != null ? tip.tip.id : "margin" + tip.margin) + idx;

		return (
			<TipButton
				isGridItem={isGridTips}
				key={tipKey}
				{...tip}
				hasPlaceHolders={shouldAddPlaceHolder}
			/>
		);
	});
}
